import React, { useEffect, useState } from 'react';
import styles from './InstagramEmbed.module.css';

interface InstagramEmbedProps {
  url: string;
  index?: number;
}

/**
 * Instagram Reel/Post Embed Component
 * Embeds Instagram content using Instagram's official embed API
 * Each embed is independently collapsible
 */
const InstagramEmbed: React.FC<InstagramEmbedProps> = ({ url, index = 0 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    // Only load Instagram embed script when expanded
    if (isExpanded) {
      if (!document.querySelector('script[src*="instagram.com/embed.js"]')) {
        const script = document.createElement('script');
        script.src = '//www.instagram.com/embed.js';
        script.async = true;
        document.body.appendChild(script);
      } else {
        // If script already exists, process embeds
        if ((window as any).instgrm) {
          (window as any).instgrm.Embeds.process();
        }
      }
    }
  }, [isExpanded]);

  return (
    <div className={styles.embedWrapper}>
      <button 
        className={styles.embedToggle}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span className={styles.embedLabel}>Video {index + 1}</span>
        <span className={`${styles.embedArrow} ${isExpanded ? styles.expanded : ''}`}>
          ▼
        </span>
      </button>
      
      {isExpanded && (
        <div className={styles.embedContainer}>
          <blockquote
            className="instagram-media"
            data-instgrm-permalink={url}
            data-instgrm-version="14"
            style={{
              background: '#FFF',
              border: 0,
              borderRadius: '3px',
              boxShadow: '0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)',
              margin: '1px',
              maxWidth: '540px',
              minWidth: '326px',
              padding: 0,
              width: 'calc(100% - 2px)',
            }}
          />
        </div>
      )}
    </div>
  );
};

export default InstagramEmbed;
